export const VERSION = {
    hash: 'release',
    version: '1.4.0',
}
